import { EventEmitter, Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ExperimentalFeaturesService {

  public enabled$ = new EventEmitter<boolean>();

  isEnabled(): boolean {
    const mode = localStorage.getItem('scr-exp');
    return (mode === 'on');
  }

  toggle() {
    let mode = localStorage.getItem('scr-exp');
    if (!mode || mode === 'off') {
      mode = 'on';
    }
    else {
      mode = 'off';
    }
    localStorage.setItem('scr-exp', mode);
    this.enabled$.emit(mode === 'on');
  }
}


